import {
  Description as DescriptionUI,
  DialogContent as UIDialogContent,
  H2,
  Slider as SliderUI,
  SliderLabel,
} from "@evergis/ui";
import styled from "styled-components";

export const Title = styled(H2)`
  margin: 0;
`;

export const Description = styled(DescriptionUI)`
  margin-top: 0.5rem;
`;

export const DialogContent = styled(UIDialogContent)`
  padding: 2.5rem 3.5rem 1rem;
  flex-direction: column;
  overflow: hidden;
`;

export const Slider = styled(SliderUI)`
  max-width: 100%;
  padding: 1.3rem 0;
  min-height: 2.5rem;

  > div {
    max-width: 100%;

    &:first-child {
      min-height: 1.5rem;
    }

    ${SliderLabel} {
      line-height: 0.875rem;
    }
  }
`;
